module.exports = __webpack_public_path__ + "static/media/yellow.66ba9e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Coinbase/yellow.png
// module id = 1044
// module chunks = 0